import { useCallback } from 'react';

import { useInternalRedirect } from '@/features/redirect';

/**
 * 契約状態更新 カスタムフック
 *
 * @returns
 */
export const useContractRenewal = () => {
  const { internalRedirectToWelcome } = useInternalRedirect();

  /**
   * 契約状態更新後の再ログインダイアログ用OKボタンのクリック処理
   */
  const clickContractRenewalOKButton = useCallback(() => {
    // ようこそ画面に遷移。このときURLパラメータの指定なし
    internalRedirectToWelcome();
  }, [internalRedirectToWelcome]);

  return {
    clickContractRenewalOKButton,
  };
};
